import { ASTNode, NodeType } from './ast.types';

export function getDependencies(node: ASTNode): string[] {
  const deps = new Set<string>();

  const traverse = (current: ASTNode) => {
    switch (current.type) {
      case NodeType.CellReference:
        deps.add(current.cellId);
        break;
      case NodeType.RangeReference:
        // Use expandRange to add every individual cell in the range as a dependency
        expandRange(current.start, current.end).forEach(id => deps.add(id));
        break;
      case NodeType.BinaryExpression:
        traverse(current.left);
        traverse(current.right);
        break;
      case NodeType.FunctionCall:
        current.args.forEach(traverse);
        break;
      default:
        break;
    }
  };

  traverse(node);
  return Array.from(deps);
}

export function parseCoords(coord: string) {
  const match = coord.match(/([A-Za-z]+)(\d+)/);
  if (!match) throw new Error(`Invalid coordinate: ${coord}`);
  
  const colStr = match[1].toUpperCase();
  const row = parseInt(match[2], 10) - 1;
  
  let col = 0;
  for (let i = 0; i < colStr.length; i++) {
    col = col * 26 + (colStr.charCodeAt(i) - 64);
  }
  return { col: col - 1, row };
}

export function toCoord(col: number, row: number): string {
  let colStr = '';
  let n = col + 1;
  while (n > 0) {
    let rem = (n - 1) % 26;
    colStr = String.fromCharCode(65 + rem) + colStr;
    n = Math.floor((n - rem) / 26);
  }
  return `${colStr}${row + 1}`;
}

export function expandRange(start: string, end: string): string[] {
  const s = parseCoords(start);
  const e = parseCoords(end);

  const startCol = Math.min(s.col, e.col);
  const endCol = Math.max(s.col, e.col);
  const startRow = Math.min(s.row, e.row);
  const endRow = Math.max(s.row, e.row);

  const cells: string[] = [];
  for (let c = startCol; c <= endCol; c++) {
    for (let r = startRow; r <= endRow; r++) {
      cells.push(toCoord(c, r));
    }
  }
  return cells;
}